import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("intro_lang") || "tr");

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const dir = current.dir;

  useEffect(() => {
    localStorage.setItem("intro_lang", lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang, dir]);

  // t("hero.title") -> nested lookup with fallback to EN then key
  const t = useCallback(
    (path) => {
      const read = (obj) => path.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);
      return read(translations[lang]) ?? read(translations.en) ?? path;
    },
    [lang]
  );

  // pick localized field: field can be a string or {tr,en,ru,ar}
  const loc = useCallback(
    (field) => {
      if (field == null) return "";
      if (typeof field === "string") return field;
      return field[lang] ?? field.en ?? Object.values(field)[0] ?? "";
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, dir, languages: LANGUAGES, t, loc }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
